// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"variant-a_textBlock__gn_9S","buttonContainer":"variant-a_buttonContainer__aV8n4","searchParam":"variant-a_searchParam__RVVsV"};